import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { LEGAL_LABEL } from "@/lib/legalContent";

const STORAGE_KEY = "sbt_cookie_consent";
const TEXT = {
  tr: "Deneyiminizi iyileştirmek için gerekli çerezleri kullanıyoruz.",
  en: "We use essential cookies to improve your experience.",
  el: "Χρησιμοποιούμε απαραίτητα cookies για να βελτιώσουμε την εμπειρία σας.",
  ru: "Мы используем необходимые файлы cookie для улучшения вашего опыта.",
  fa: "برای بهبود تجربه شما از کوکی‌های ضروری استفاده می‌کنیم.",
};
const ACCEPT = { tr: "Kabul Et", en: "Accept", el: "Αποδοχή", ru: "Принять", fa: "پذیرفتن" };

export default function CookieConsent() {
  const { lang } = useParams();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) setShow(true);
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, "accepted");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-consent"
      className="fixed bottom-16 lg:bottom-6 inset-x-3 lg:inset-x-auto lg:right-6 lg:max-w-md z-50 rounded-2xl border border-white/10 bg-graphite/95 backdrop-blur-md p-5 shadow-2xl shadow-black/50"
    >
      <div className="flex items-start gap-3">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-copper/15 text-copper">
          <Cookie size={18} />
        </span>
        <div className="flex-1">
          <p className="text-sm text-ink leading-relaxed">
            {TEXT[lang] || TEXT.en}{" "}
            <Link to={`/${lang}/privacy`} className="text-copper hover:underline" data-testid="cookie-privacy-link">
              {(LEGAL_LABEL.privacy[lang] || LEGAL_LABEL.privacy.en)}
            </Link>
          </p>
          <button
            onClick={accept}
            data-testid="cookie-accept-btn"
            className="btn-copper mt-4 !py-2 !px-6 text-sm"
          >
            {ACCEPT[lang] || ACCEPT.en}
          </button>
        </div>
      </div>
    </div>
  );
}
